<template>
  <div class="history-list">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Select v-model="formItem.cate_id"
                :style="{'width':'180px'}">
          <Option value
                  key="全部">全部</Option>
          <Option v-for="item in catelist"
                  :value="item.id"
                  :key="item.id">{{item.title}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入标题或事件时间查询..."
               style="width:200px"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
      <FormItem>
        <Button @click="showModel()"
                type="success"
                class="f-r">添加消息</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="history"
            ref="historyValidate"
            action="javascript:void(0)">
        <FormItem label="分类"
                  label-position="top">
          <Select v-model="history.catid"
                  clearable
                  filterable
                  placeholder="选择分类">
            <Option v-for="item in catelist"
                    :value="item.id"
                    :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称">
          <Input v-model="history.title"
                 placeholder="请输入标题" />
        </FormItem>
        <FormItem label="省-市-县"
                  label-position="top">
          <Select v-model="history.area1"
                  placeholder="省"
                  @on-change="shengChange">
            <Option v-for="item in shengList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" "
                  label-position="top">
          <Select v-model="history.area2"
                  placeholder="市"
                  @on-change="shiChange">
            <Option v-for="item in shiList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" "
                  label-position="top">
          <Select v-model="history.area3"
                  placeholder="县">
            <Option v-for="item in quList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="发布时间">
          <Input v-model="history.push_at"
                 placeholder="例如：2020-07-08" />
        </FormItem>
        <FormItem label="外部链接">
          <Input v-model="history.web_url"
                 placeholder="请输入完整链接地址" />
        </FormItem>
        <FormItem label="描述">
          <Input type="textarea"
                 v-model="history.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <!-- <FormItem label="封面图">
          <upload-thumb v-model="history.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*1028,大小不超过2M'"></upload-thumb>
        </FormItem> -->
        <FormItem label="内容">
          <!--          <editor-bar v-model="history.content" :isClear="isClear" ref="editContent"></editor-bar>-->
          <UEditor v-model="history.content"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="道具">
          <Select v-model="history.daoju"
                  multiple
                  style="width:260px">
            <Option v-for="item in daojuList"
                    :value="item.id"
                    :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否推荐">
          <RadioGroup v-model="history.pos_flag">
            <Radio :label="0"
                   border>否</Radio>
            <Radio :label="1"
                   border>是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="排序">
          <Input v-model="history.sort"
                 placeholder="请输入排序" />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="createpushtype('historyValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";

export default {
  name: "history-list",
  data () {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      isClear: false,
      dataloading: true,
      showModalStatus: false,
      catelist: [],
      daojuList: [],
      shengList: [],
      shiList: [],
      quList: [],
      history: {
        pos_flag: 0,
        daoju: []
      },
      formItem: {},
      thumblist: [],
      pages: {
        current: 1,
        total: 0,
        size: 20
      },
      columns1: [
        {
          title: "排序",
          width: 80,
          key: "sort"
        },
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "标题",
          minWidth: 200,
          key: "title"
        },
        {
          title: "角色",
          minWidth: 200,
          key: "role"
        },
        {
          title: "发布人",
          minWidth: 200,
          key: "admin_name"
        },
        {
          title: "发布时间",
          minWidth: 200,
          key: "push_at"
        },
        {
          title: "分类",
          width: 150,
          key: "cateid",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.cate.title == "" ? "" : params.row.cate.title
              )
            ]);
          }
        },
        {
          title: "状态",
          width: 150,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == "0" ? "禁用" : "正常")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 330,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 1);
                    }
                  }
                },
                "正常"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "1" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 0);
                    }
                  }
                },
                "禁用"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: []
    };
  },
  components: {
    UploadThumb,
    UEditor
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
    //取分类
    this.getCateList();
    //获取道具
    this.getDaoJu();
    this.getShengList();
  },
  methods: {
    getTableList: function () {
      var self = this;
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.history.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getCateList: function () {
      this.$api.historycate.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.catelist = res.result;
        }
      });
    },
    getDaoJu: function () {
      this.$api.historydaoju
        .list({
          status: 0
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.daojuList = res.result;
          }
        });
    },
    // 展开添加
    showModel () {
      this.historyid = 0;
      this.history = {
        pos_flag: 0
      };
      this.thumblist = new Array();
      this.$refs["editContent"].message = "";
      this.$refs["historyValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function (index) {
      this.historyid = index;
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.history.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.history = res.result;
          for (var i in this.history.daoju) {
            this.history.daoju[i] = Number(this.history.daoju[i]);
          }
          // if (this.history.thumb != null && this.history.thumb != "") {
          //   this.thumblist.push({
          //     name: this.history.thumb,
          //     url: this.history.thumb,
          //     status: "finished"
          //   });
          // }
          //省市区三个下拉框
          this.shiList = this.history.shiList;
          this.quList = this.history.quList;
        }
        this.$refs["editContent"].message = this.history.content;
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype (name) {
      // if (this.$refs["uploadthumb"].uploadList.length > 0) {
      //   this.history.thumb = this.$refs["uploadthumb"].uploadList[0].url;
      // } else {
      //   this.history.thumb = null;
      // }
      this.history.content = this.$refs["editContent"].message;
      if (
        this.historyid == null ||
        this.historyid == 0 ||
        this.historyid == undefined
      ) {
        this.$api.history.create(this.history).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.renderTable();
          }
        });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      } else {
        //编辑商品
        this.history.id = this.historyid;
        this.$api.history.edit(this.history).then(res => {
          if (res.code == 200) {
            this.renderTable();
            this.showModalStatus = false;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.history.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.renderTable();
            }
          });
        }
      });
    },
    review: function (id, index) {
      this.$api.history.status({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable();
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      var self = this;
      var ps = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        cateid: this.formItem.cate_id
      };
      this.$api.history.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    }
  }
};
</script>
